export default __webpack_public_path__ + "static/hero-bg-422ebc796cc5ffd132d30e8fbdb631b6.webp";